class ClickGate {
  constructor() {}
  enable() {
    document.querySelector('.clickGate').style.display = 'block';
  }

  disable() {
    document.querySelector('.clickGate').style.display = 'none';
  }
}

export default new ClickGate();
